export enum DiscountType {
    DefaultDiscount = 0,
    Code = 1,
    Bonus = 2,
    DiscountWithPaymentCondition = 3
}